<template>
  <div id="page">
    <!-- 要有:page-size(每頁的筆數)和:total為總比數-->
    <!-- current-page為當前頁數 -->
    <el-pagination
      :key="paginationKey"
      layout="total, prev, pager, next, jumper"
      :page-size="pageSize"
      :total="totalLists"
      :current-page="internalCurrentPage"
      @current-change="currentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { notify } from '../utils/notify';

export default {
  props: {
    totalLists:{
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    propsCurrentPage: {
      type: Number,
      required: true,
    },
    maxPageLimit: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      internalCurrentPage: this.propsCurrentPage,
      paginationKey: 0
    };
  },
  watch: {
    propsCurrentPage(newVal) {
      this.internalCurrentPage = newVal;
    }
  },
  methods: {
    currentChange(val) {
      // console.log("current page", val);
      // 只有外部傳入頁數上限時才啟用限制
      if (this.maxPageLimit && val > this.maxPageLimit) {
        notify({
          title: "提示",
          message: `頁數不可超過 ${this.maxPageLimit} 頁`,
          type: "warning"
        });
        // 重置回原來的頁碼並強制重新渲染
        this.$nextTick(() => {
          this.internalCurrentPage = this.propsCurrentPage;
          this.paginationKey++; // 強制重新渲染以清空 jumper 輸入框
        });
        return;
      }
      this.internalCurrentPage = val;
      this.$emit("currentChange", val);
    },
  },
};
</script>

<style lang="scss" scoped>
#page {
  width: 100%;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .el-select {
    margin-left: 16px;
    width: 110px;
  }
}
</style>
